import { createSlice } from "@reduxjs/toolkit";
import {
  postSubmitRFP,
  postSubmitRFPWithLogin,
} from "../../thunks/common-thunks/commonThunk";

const initialState = {
  isLoading: false,
  rfpStatus: "idle", // "idle" | "loading" | "success" | "failed"
  rfpStatusMsg: null,
  error: null,
  user: null,
  updateSubmitRfpResult: null,
};

export const submitRfpSlice = createSlice({
  name: "submitrfp",
  initialState,
  reducers: {
    RESET_RFP: (state) => {
      state.rfpStatus = null;
      state.updateSubmitRfpResult = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(postSubmitRFP.pending, (state) => {
        state.isLoading = true;
        state.rfpStatus = "loading";
        state.error = null;
      })
      .addCase(postSubmitRFP.fulfilled, (state, action) => {
        state.isLoading = false;
        state.rfpStatus = "success";
        state.updateSubmitRfpResult = action.payload.message;
      })
      .addCase(postSubmitRFP.rejected, (state, action) => {
        state.isLoading = false;
        state.rfpStatus = "failed";
        state.error = action.error?.message || "Something went wrong";
      });

    builder
      .addCase(postSubmitRFPWithLogin.pending, (state) => {
        state.isLoading = true;
        state.rfpStatus = "loading";
        state.error = null;
      })
      .addCase(postSubmitRFPWithLogin.fulfilled, (state, action) => {
        state.isLoading = false;
        state.rfpStatus = "success";
        state.updateSubmitRfpResult = action.payload.message;
      })
      .addCase(postSubmitRFPWithLogin.rejected, (state, action) => {
        state.isLoading = false;
        state.rfpStatus = "failed";
        state.error = action.error?.message || "Something went wrong";
      });
  },
});
export const { RESET_RFP } = submitRfpSlice.actions;
export default submitRfpSlice.reducer;
